/* unplugin-vue-components disabled */import { render } from "./QuizQuestionComplementaryInfoEditor.vue?vue&type=template&id=3239f2f0&ts=true"
import script from "./QuizQuestionComplementaryInfoEditor.vue?vue&type=script&lang=ts"
export * from "./QuizQuestionComplementaryInfoEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__